import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { TextField, Modal } from '@material-ui/core'
import { useStyles } from '../MaterialUiModal'
import BootstrapAlert from '../element/BootstrapAlert'
import ErrorBoundary from '../ErrorBoundary'

export default function TradeDraftModal (props) {
  const classes = useStyles()
  const [modalOpen, setModalOpen] = useState(false)
  const commentInput = useRef(null)

  useEffect(() => {
    $('button.open-trade-draft-modal').each((i, el) => {
      $(el).on('click', () => setModalOpen(true))
    })
    $('#' + props.formId).each((i, el) => {
      const input = document.createElement('input')
      input.className = 'd-none'
      input.name = 'trade_draft_comment'
      input.value = props.comment
      commentInput.current = input
      el.appendChild(input)
    })
  }, [])

  return (
    <Modal
      className={classes.modal}
      open={modalOpen}
      onClose={() => setModalOpen(false)}>
      <div className={classes.paper}>
        <h2>下書きコメント入力</h2>
        <hr />
        <p>下書き一覧に表示されるコメントを入力できます。</p>
        <BootstrapAlert class={'primary'}>
          <>
            下書きの閲覧・編集は、対象アイテムをすべて閲覧できるアカウントにのみ許可されます。<br/>
            他のアカウントから閲覧できない場合は、契約の共有設定をご確認いただき、共有グループへのアカウントの追加をお願いします。
          </>
        </BootstrapAlert>
        <TextField
          variant="standard"
          id='trade-draft-comment'
          name="trade_draft_comment"
          type='text'
          defaultValue={props.comment}
          label='コメント（下書き一覧に表示されます）'
          placeholder=""
          multiline={false}
          className='w-100 mb-2'
          inputProps={{
            maxLength: 170
          }}
          onChange={(e) => {
            if (commentInput.current) {
              commentInput.current.value = e.target.value
            }
          }}
        >
        </TextField>
        <hr />
        <div className="row theme-3">
          <div className="col-6">
            <button type='button' className='btn btn-outline-secondary' onClick={() => setModalOpen(false)}>
              キャンセル
            </button>
          </div>
          <div className="col-6 text-right">
            <button type='submit' form={props.formId} name="save-as-draft" className='btn bg-theme-primary' onClick={(e) => { window.onbeforeunload = null }}>
              下書きとして保存
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

TradeDraftModal.propTypes = {
  formId: PropTypes.string,
  comment: PropTypes.string
}

$('.trade-draft-modal').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <TradeDraftModal {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
